export { default } from './Boleto25Stack';
